import React, { useState } from 'react'
import { Typography } from '../ui/typography';

export default function List({ items, onClick }) {
    const [hover, setHover] = useState([]);

    const toggle = (id) => {
        let tmpItem = Object.assign([], hover);
        if (tmpItem.indexOf(id) >= 0) {
            tmpItem = tmpItem.filter(item => item !== id)
            setHover([])
        } else {
            tmpItem.push(id)
            setHover(tmpItem)
        }
    }

    return (
        < >
      
            {items
                .map(item => {
                    return <div key={item._id} onClick={() => { onClick(item) }} className="card shadow radius-right" onMouseOver={() => { toggle(item._id) }} onMouseOut={() => { toggle(item._id) }}>
                        <div className="card-image" style={{borderRadius:'0px 40px 0px 0px', backgroundImage: 'url(' + (item.image || 'http://localhost:3001/chart.png') + ')' ,backgroundPosition:'center center'}}></div>
                        <div className="card-line">&nbsp;</div>
                        <div className="card-content">
                            <Typography component="h3">{item.title}</Typography>

                            <i>{item.description}</i>
                        </div>
                     
                    </div>
                })}
        </>
    )
}
